import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { getStaffCounsels } from '../api/employeesCounsel.api';
import { ICounsel, IGetCounsels } from '../models/employeesCounsel.model';

interface ICounselState {
  staffCounsels: ICounsel[];
  isLoading: boolean;
  error?: AxiosError | string;
};

const initialState: ICounselState = {
  staffCounsels: [],
  isLoading: false
};

const staffCounselSlicer = createSlice({
  name: 'staffCounsel',
  initialState,
  reducers: {
    getCounselsStart: (state: ICounselState) => {
      state.staffCounsels = [];
      state.isLoading = true;
      state.error = undefined;
    },
    getCounselsSuccess: (state: ICounselState, action: PayloadAction<IGetCounsels>) => {
      state.staffCounsels = action.payload.data;
      state.isLoading = false;
      state.error = undefined;
    },
    getCounselsFailure: (state: ICounselState, action: PayloadAction<AxiosError|string>) => {
      state.staffCounsels = [];
      state.isLoading = false;
      state.error = action.payload;
    },
  }
});

export const {
  getCounselsStart,
  getCounselsSuccess,
  getCounselsFailure,
} = staffCounselSlicer.actions;

export default staffCounselSlicer.reducer;

export const doGetStaffCounsels = (memberCode: string): any => async (dispatch: any) => {
  try {
    dispatch(getCounselsStart());
    const response = await getStaffCounsels(memberCode);
    dispatch(getCounselsSuccess(response.data));
    return response;
  } catch (e: any) {
    dispatch(getCounselsFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};
